'use client'

import PreviewItem from '@/components/main/PreviewItem'
import MoReviewItem from '@/components/main/MoPreviewItem'
import { useTranslation } from 'react-i18next'
import { IPreviewItem } from '@/types/main'
import { GA_EVENTS } from '@/utils/analytics'
import { useEffect } from 'react'

const PreviewSection = () => {
  const { t } = useTranslation('home')

  const PREVIEW_RAW = t('preview_data', {
    returnObjects: true
  }) as unknown

  const PREVIEW_DATA: IPreviewItem[] = Array.isArray(PREVIEW_RAW)
    ? (PREVIEW_RAW as IPreviewItem[])
    : Object.values((PREVIEW_RAW as Record<string, IPreviewItem>) || {})

  useEffect(() => {
    GA_EVENTS.SECTION_VIEW('preview_section')
  }, [])

  return (
    <section className="mx-0 sm:mx-auto sm:mt-[180px]">
      {PREVIEW_DATA.map((item, index) => (
        <div key={index}>
          <div className="hidden sm:block">
            <PreviewItem item={item} index={index} />
          </div>
          <div className="sm:hidden">
            <MoReviewItem item={item} index={index} />
          </div>
        </div>
      ))}
    </section>
  )
}

export default PreviewSection
